export class TeachrIban {
    iban: string
    constructor(iban: string) {this.iban = iban}
}